export const CalcValueCellRenderer = ({ value, colDef, data }) => {
  let moneyNf = new Intl.NumberFormat('en-US', { minimumFractionDigits: 6 });

  if (value == null) {
    return <span></span>;
  } else if (!isNaN(value) && data?.code !== 'LINKED11' && data?.code !== 'NDC11' && data?.code !== 'NDC9') {
    value = moneyNf.format(value);
  }

  // CalcProdPp/CalcProdRes also carry calcId (Calc is their composite root), so check the more specific fields first
  let entity = '';
  if (data?.ppSrcCode != null) {
    entity = 'CALC_PROD_PP';
  } else if (data?.calcProdId != null || data?.calcProdId0 != null || data?.calcProdId1 != null) {
    entity = 'CALC_PROD_RES';
  } else if (data?.calcId != null || data?.calcId1 != null) {
    entity = 'CALC_PROD';
  }

  if (entity !== '') {
    const isDollar = entity === 'CALC_PROD' || entity === 'CALC_PROD_PP' || isDollarRes(data);

    if (isDollar) {
      if (!isNaN(data?.value) && Number(data.value) < 0) {
        value = '-$' + Math.abs(data.value);
      } else {
        value = '$' + value;
      }
    }
  }

  return <span>{value}</span>;
};

// Formulas carry no unit metadata, so non-monetary results are identified by their code/name wording
const NON_DOLLAR_RE = /percent|pct|\brates?\b|quantity|qty|\bunits?\b|count|ratio|quarter/i;

const isDollarRes = (data) => {
  if (data == null) {
    return false;
  }
  if (data.code?.endsWith('_LIAB')) {
    return true;
  }
  if (data.type === 'FINAL' || data.type === 'INTER') {
    return !NON_DOLLAR_RE.test((data.code ?? '') + ' ' + (data.name ?? ''));
  }
  return data.name?.endsWith(' Amount') || (data.name ?? '').includes('$');
};
